import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import ProjectDetail from './pages/ProjectDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProjectForm from './pages/admin/AdminProjectForm';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/portfolio" element={<><Header /><Portfolio /><Footer /></>} />
          <Route path="/project/:id" element={<><Header /><ProjectDetail /><Footer /></>} />
          <Route path="/about" element={<><Header /><About /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            } 
          />
          <Route 
            path="/admin/projects/new" 
            element={
              <ProtectedAdminRoute>
                <AdminProjectForm />
              </ProtectedAdminRoute>
            } 
          />
          <Route 
            path="/admin/projects/edit/:id" 
            element={
              <ProtectedAdminRoute>
                <AdminProjectForm />
              </ProtectedAdminRoute>
            } 
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
